import { combineReducers } from 'redux';
import { simpleReducer } from '@mgc/map-client-shared/lib/ReduxTools';

export default combineReducers({
    uploadInTransit: simpleReducer(false, {
        CONFIGURATION_SHEET_UPLOADING: true,
        CONFIGURATION_SHEET_UPLOAD_SUCCESS: false,
        CONFIGURATION_SHEET_UPLOAD_DUPLICATE: false,
        CONFIGURATION_SHEET_UPLOAD_ERROR: false,
    }),

    downloadSpinner: simpleReducer(false, {
        SET_DOWNLOAD_SPINNER:  (a) => a.payload,
    }),

    dragOver: simpleReducer(false, {
        SET_DRAG_OVER: (a) => a.payload.boolVal,
    }),

    unknownFileType: simpleReducer(false, {
        SET_UNKOWN_FILETYE: (a) => a.payload.boolVal,
    }),

    fileUploaded: simpleReducer(null, {
        CONFIGURATION_SHEET_UPLOADING: (a) => a.payload.file,
    }),

    uploadError: simpleReducer(null, {
        CONFIGURATION_SHEET_UPLOADING: null,
        CONFIGURATION_SHEET_UPLOAD_SUCCESS: null,
        CONFIGURATION_SHEET_UPLOAD_ERROR: function (a) {
            return a.payload.error;
        },
    }),

    excelUploadErrorResponse: simpleReducer(
        {},
        {
            CONFIGURATION_SHEET_UPLOAD_ERROR_RESPONSE: (a) =>
                a.payload.error.data,
            CLEAR_EXCEL_SHEET_UPLOAD_ERROR_RESPONSE: {},
        }
    ),

    uploadTotal: simpleReducer(0, {
        CONFIGURATION_SHEET_UPLOADING: (a) => a.payload.file.size,
        CONFIGURATION_SHEET_UPLOAD_PROGRESS: (a) => a.payload.total,
    }),

    uploadProgress: simpleReducer(0, {
        CONFIGURATION_SHEET_UPLOADING: 0,
        CONFIGURATION_SHEET_UPLOAD_PROGRESS: (a) => a.payload.complete,
        CONFIGURATION_SHEET_UPLOAD_ERROR: 0,
        PRICE_SHEET_UPLOAD_DUPLICATE: 0,
    }),

    catchedErrorMessage: simpleReducer(0, {
        SET_ERROR_MESSAGE: (a) => a.payload.message,
    }),

    supermanReducer: simpleReducer('', {
        SUPERMAN: (a) => a.payload.message,
    }),

    configurationSheetUploadInTransit: simpleReducer(false, {
        REQUESTING_CONFIGURATION_SHEET: true,
        RECEIVED_CONFIGURATION_SHEET_RESPONSE: false,
    }),

    configurationSheetUploadResponse: simpleReducer(
        {},
        {
            REQUESTING_CONFIGURATION_SHEET_RESPONSE: [],
            RECEIVED_CONFIGURATION_SHEET_RESPONSE: (a) => a.payload.response,
        }
    ),

    downloadInProgress: simpleReducer(false, {
        DOWNLOADING_PRICING: true,
        DOWNLOADED_PRICING: false,
        DOWNLOADING_ALL_PRICING: true,
        DOWNLOADED_ALL_PRICING: false,
    }),
});



// WEBPACK FOOTER //
// ./app/reducers/uploadConfiguration.js